import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableLoyalty',
  initialState: false,
  reducers: {
    setDisableLoyalty(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableLoyalty } = slice.actions;

export default slice.reducer;
